import script from "./NotFound.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFound.vue?vue&type=script&lang=ts&setup=true"

import "./NotFound.vue?vue&type=style&index=0&id=7db265c6&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db265c6"]])

export default __exports__